import Axios from 'axios';
import config from '@/config';

export default Axios.create({
  baseURL: config.backend.baseUrl,
  withCredentials: config.backend.cors.credentials,
});
